import React from 'react';
import Header from '../components/Header';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight';
import { getDeputyTitleFromRouteId } from '../utils/deputy';
import { getBackgroundImage } from '../utils/organization';

export default function HomePage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;

  const navItems = [
    {
      num: '01',
      title1: t('structure'),
      title2: currentLanguage === 'id' ? 'ORGANISASI' : 'ORGANIZATION',
      route: `/organization/${id}`,
    },
    {
      num: '02',
      title1: currentLanguage === 'en' ? t('achievement') : t('attainment'),
      title2: currentLanguage === 'id' ? t('achievement') : undefined,
      route: `/achievement/${id}`,
    },
    {
      num: '03',
      title1: t('documentation'),
      title2: t('fromTimeToTime'),
      route: `/gallery/${id}`,
    },
  ];

  const bgImage = getBackgroundImage(id);
  const deputyTitle = getDeputyTitleFromRouteId(id, t);

  return (
    <div
      className="min-h-screen w-full bg-[#002D4B] flex flex-col justify-between text-white bg-cover bg-no-repeat relative overflow-x-hidden overflow-y-auto"
      style={{
        backgroundImage: `linear-gradient(180deg, rgba(0, 30, 49, 0.88) 0%, rgba(0, 45, 75, 0.95) 100%), url(${bgImage})`,
      }}
    >
      <div className="w-full max-w-[1500px] mx-auto px-4 md:px-[60px] min-h-screen flex flex-col justify-between py-[24px] relative z-10">
        <Header />

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-[40px] my-auto w-full flex-1 items-center py-[16px]">
          {/* Navigation Items Column */}
          <div className="lg:col-span-7 h-[460px] flex flex-col justify-between">
            {navItems.map((nav, idx) => (
              <div
                key={idx}
                className="h-[136px] px-[36px] w-full flex justify-between items-center cursor-pointer bg-slate-900/70 hover:bg-[#002D4B]/95 border border-white/15 hover:border-[#00AFDD] rounded-2xl transition-all duration-300 transform hover:translate-x-2 active:scale-[0.98] shadow-xl hover:shadow-[0_8px_25px_rgba(0,175,221,0.25)] group backdrop-blur-md"
                onClick={() => navigate(nav.route)}
              >
                <div className="flex items-center space-x-[24px]">
                  <div className="text-xl md:text-2xl font-black font-mono text-[#00AFDD] bg-[#00AFDD]/10 border border-[#00AFDD]/30 w-[54px] h-[54px] flex items-center justify-center rounded-xl group-hover:bg-[#00AFDD] group-hover:text-slate-950 transition-all flex-shrink-0">
                    {nav.num}
                  </div>
                  <div>
                    <div className="text-xl md:text-2xl font-extrabold uppercase tracking-wide text-white group-hover:text-[#00AFDD] transition-colors leading-tight">
                      {nav.title1}
                    </div>
                    {nav.title2 && (
                      <div className="text-lg md:text-xl font-bold uppercase tracking-wide text-slate-300 group-hover:text-white transition-colors leading-tight">
                        {nav.title2}
                      </div>
                    )}
                  </div>
                </div>

                <ArrowCircleRightIcon
                  className="text-white/60 group-hover:text-[#00AFDD] group-hover:translate-x-2 transition-all duration-300 flex-shrink-0"
                  sx={{ fontSize: 44 }}
                />
              </div>
            ))}
          </div>

          {/* Active Division Hero Card Column */}
          <div className="lg:col-span-5 h-[460px] flex items-center">
            <div
              className="w-full h-full rounded-3xl bg-cover bg-center p-[36px] flex flex-col justify-between border border-white/20 shadow-2xl relative overflow-hidden group transform transition-transform duration-500 hover:scale-[1.01]"
              style={{
                backgroundImage: `linear-gradient(180deg, rgba(0, 0, 0, 0.25) 0%, rgba(0, 30, 49, 0.95) 100%), url(${bgImage})`,
              }}
            >
              <div className="flex justify-between items-start">
                <span className="text-xs uppercase font-extrabold tracking-widest text-[#00AFDD] bg-[#001E31]/90 px-[16px] py-[8px] rounded-full border border-[#00AFDD]/40 backdrop-blur-md shadow-md">
                  KEDEPUTIAN BNN RI
                </span>
              </div>
              <div className="relative z-10 space-y-[12px]">
                <h2 className="text-2xl md:text-3xl lg:text-4xl font-extrabold uppercase tracking-wider text-white leading-tight drop-shadow-lg">
                  {deputyTitle}
                </h2>
                <div className="w-[100px] h-[6px] bg-[#00AFDD] rounded-full"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
